import React from 'react';
import { Phone, Mail, MapPin, Facebook } from 'lucide-react';
import { businessInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="mb-4">
              <h3 className="text-2xl font-bold text-amber-400 mb-2">{businessInfo.name}</h3>
              <p className="text-slate-300 leading-relaxed">
                Professional kitchen, bathroom, and bedroom installation services across West Midlands. 
                Quality craftsmanship and reliable service you can trust.
              </p>
            </div>
            <div className="flex gap-4 mt-6">
              <a 
                href="https://www.facebook.com/share/14NGAWgfxxs/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 hover:bg-amber-500 rounded-lg flex items-center justify-center transition-colors"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-slate-300 hover:text-amber-400 transition-colors">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-slate-300 hover:text-amber-400 transition-colors">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('gallery')} className="text-slate-300 hover:text-amber-400 transition-colors">
                  Gallery
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="text-slate-300 hover:text-amber-400 transition-colors">
                  Testimonials
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-slate-300 hover:text-amber-400 transition-colors">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-amber-400 flex-shrink-0 mt-1" />
                <a href={`tel:${businessInfo.phone}`} className="text-slate-300 hover:text-amber-400 transition-colors">
                  {businessInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-amber-400 flex-shrink-0 mt-1" />
                <a href={`mailto:${businessInfo.email}`} className="text-slate-300 hover:text-amber-400 transition-colors break-all">
                  {businessInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-amber-400 flex-shrink-0 mt-1" />
                <span className="text-slate-300">{businessInfo.location}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-8 pt-8 text-center text-slate-400">
          <p>&copy; {currentYear} {businessInfo.name}. All rights reserved.</p>
          <p className="mt-2 text-sm">Professional Kitchen & Bathroom Installation Services</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;